import { List, Tag, Typography } from 'antd';
import { useNotificationStore } from '@store/notificationStore';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';
import { fromNow } from '@/utils';

function NotificationWidget(_: WidgetRenderProps) {
  const items = useNotificationStore((s) => s.items);

  const colorMap = { info: 'blue', success: 'green', warning: 'orange', error: 'red' } as const;

  return (
    <List
      size="small"
      dataSource={items.slice(0, 20)}
      style={{ height: '100%', overflow: 'auto' }}
      locale={{ emptyText: 'No notifications' }}
      renderItem={(n) => (
        <List.Item>
          <List.Item.Meta
            title={
              <>
                <Tag color={colorMap[n.level]}>{n.level}</Tag>
                <Typography.Text strong>{n.title}</Typography.Text>
              </>
            }
            description={
              <>
                <Typography.Paragraph style={{ marginBottom: 4 }}>{n.message}</Typography.Paragraph>
                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                  {fromNow(n.createdAt)}
                </Typography.Text>
              </>
            }
          />
        </List.Item>
      )}
    />
  );
}

export const notificationWidgetDef: WidgetDefinition = {
  type: 'notification',
  name: 'Notifications',
  description: 'Live notification feed',
  icon: 'BellOutlined',
  category: 'system',
  defaultTitle: 'Notifications',
  defaultConfig: {},
  minW: 3,
  minH: 4,
  defaultW: 4,
  defaultH: 8,
  component: NotificationWidget,
  settingsSchema: { fields: [] },
};
